import { render } from "./RelacionVideoCap.vue?vue&type=template&id=6bca886c&scoped=true"
import script from "./RelacionVideoCap.vue?vue&type=script&lang=js"
export * from "./RelacionVideoCap.vue?vue&type=script&lang=js"

import "./RelacionVideoCap.vue?vue&type=style&index=0&id=6bca886c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bca886c"]])

export default __exports__